import { NgModule } from '@angular/core';
import { OneSchemaModule } from '@oneschema/angular';

import { environment } from '@ninety/ui/web/environments';

import { OneSchemaTemplateKey } from './models/one-schema-template-key';

@NgModule({
  imports: [
    OneSchemaModule.forRoot({
      manageDOM: false,
      clientId: environment.oneSchemaClientId,
      templateKey: OneSchemaTemplateKey.users,
      styles: {
        width: '99.8%',
        height: 'calc(100vh - 260px)',
        border: 'none',
      },
      devMode: !environment.production,
      saveSession: false,
      /** figure out how to get this to work */
      // eventWebhookKeys: ['fileUploaded'],
    }),
  ],
})
export class OneSchemaDataImportModule {}
